export function ContactForm() {
    $(document).ready(function () {
        if ($("body.Contact").length >= 1) {
            setupForm();
        }
    });

    function setupForm() {
        var forms = $(".contact.section").find("form");
        if (forms.length !== 1) {
            return;
        }
        const form = forms[0];

        //$(form).find("input").each(function () {
        //    $(this).on("input",
        //        () => {
        //            validateForm(form);
        //        });
        //});

        //$(form).find("textarea").each(function () {
        //    $(this).on("change keyup paste",
        //        () => {
        //            validateForm(form);
        //        });
        //});
        class DataObject {
            Name: string;
            Email: string;
            Comment: string;
            Subject: string;
            Company: string;
            'g-recaptcha-response': string;
        };

        $(form).submit(function (e) {
            e.preventDefault();
            var submitBtn = $($(form).find('input[type="submit"]')[0]);
            submitBtn.attr('disabled', 'disabled');
            submitBtn.val('Processing...');

            var formValid = validateForm(this);

            if (formValid) {

                var name = getFieldValue(form, "#Name");
                var email = getFieldValue(form, "#Email");
                var message = getFieldValue(form, "#Comment");
                var subject = getFieldValue(form, "#Subject");
                var company = getFieldValue(form, "#Company");
                var catpcha = getFieldValue(form, "#g-recaptcha-response");

                let formData = new DataObject();
                formData.Name = name;
                formData.Email = email;
                formData.Comment = message;
                formData.Subject = subject;
                formData.Company = company;
                formData["g-recaptcha-response"] = catpcha;

				$.post($(this).attr("action"), formData).done((response: any) => {
					$('body, html').animate({ scrollTop: $('form').offset().top },
						1000,
						function () {
							$('.contact-us-form .form-elements').hide(1000,
								function () {
									submitBtn.removeAttr('disabled');
									if (response.HasErrors) {
										$('.submit-message.error').show(1000);
									} else {
										$('.submit-message.success').show(1000);
									}
								}
							);
					});
                });
            } else {
                submitBtn.removeAttr('disabled');
                submitBtn.val('SUBMIT');
            }
        });
    }

    function validateElement(input: string, form: HTMLElement, errorClass: string, elementId: string): boolean {
        var isValid = true;
        if (EmptyString(input)) {
            isValid = false;

            removeElement(errorClass);
                $("<div class='validation-error'>This field is required.</div>").addClass(errorClass.replace('.', '')).insertAfter(
                    FieldElement(form, elementId));
        } else {
            removeElement(errorClass);
        }
        return isValid;
    }

    function validateEmailFormat(input: string, form: HTMLElement, errorClass: string, elementId: string): boolean {
        var isValid = true;
        const emailRegEx = "";
        if (!EmptyString(input)) {
            var regex = /^[\w\.=-]+@[\w\.-]+\.[\w]{2,3}$/g;
            var test = regex.test(input);
            if (!test) {
                isValid = false;
                removeElement(errorClass);
                $("<div class='validation-error'>Please enter a valid email.</div>").addClass(errorClass.replace('.', ''))
                    .insertAfter(
                        FieldElement(form, elementId));
            } else {
                removeElement(errorClass);
            }
        }

        return isValid;
    }

    class validation {
        constructor() {
            this.validations = new Array as Array<Boolean>;
        }
        validations: Array<Boolean>;
        valid(): boolean {
            var isValid = true;
            for (var i = 0; i < this.validations.length; i++) {
                if (!this.validations[i]) {
                    isValid = false;
                }
            }
            return isValid;
        }
    }

    function validateForm(form: HTMLElement): boolean {

        var name = getFieldValue(form, "#Name");
        var email = getFieldValue(form, "#Email");
        var message = getFieldValue(form, "#Comment");
        var subject = getFieldValue(form, "#Subject");
        var company = getFieldValue(form, "#Company");
        var catpcha = getFieldValue(form, "#g-recaptcha-response");

        var validations = new validation();
        validations.validations.push(validateElement(name, form, ".name-error", "#Name"));
        validations.validations.push(validateElement(email, form, ".email-error", "#Email"));
        validations.validations.push(validateEmailFormat(email, form, ".email-error", "#Email"));
        validations.validations.push(validateElement(message, form, ".message-error", "#Comment"));
        validations.validations.push(validateElement(catpcha, form, ".captcha-error", ".g-recaptcha"));
        validations.validations.push(validateElement(subject, form, ".subject-error", "#Subject"));
        validations.validations.push(validateElement(company, form, ".company-error", "#Company"));

        return validations.valid();
    }

    function FieldElement(form: HTMLElement, field: string) {
        return $(form).find(field)[0] === undefined ? null : $($(form).find(field)[0]);
    }

    function getFieldValue(form: HTMLElement, field: string): string {
        return FieldElement(form, field).val() as string;
    }

    function removeElement(element: string) {
        try {
            $(element).remove();
        } catch (ex) {
            //null ref remove;
        }
    }

    function EmptyString(input: string): boolean {
        if (input === "") return true;
        return false;
    }
}